<template>
  <el-card v-if="favorites.length > 0 || recents.length > 0" shadow="never" class="home-dashboard__card home-shortcuts">
    <div slot="header">
      <span class="home-dashboard__card-title">{{ $t("atalhos") }}</span>
    </div>
    <template v-if="favorites.length > 0">
      <div class="home-shortcuts__group-title">{{ $t("favoritos") }}</div>
      <div class="home-shortcuts__links">
        <a
          v-for="item in favorites"
          :key="`fav-${item.path}`"
          class="home-shortcuts__link"
          @click.prevent="$router.push(item.path)"
        >
          <i class="el-icon-star-on"></i>{{ $t(item.name) }}
        </a>
      </div>
    </template>
    <template v-if="recents.length > 0">
      <div class="home-shortcuts__group-title">{{ $t("acessos-recentes") }}</div>
      <div class="home-shortcuts__links">
        <a
          v-for="item in recents"
          :key="`rec-${item.path}`"
          class="home-shortcuts__link"
          @click.prevent="$router.push(item.path)"
        >
          <i class="el-icon-time"></i>{{ $t(item.name) }}
        </a>
      </div>
    </template>
  </el-card>
</template>

<script>
// Atalhos pessoais: favoritos vêm do menu do usuário (estrela, tabela
// user_favorite — investimento que o usuário já fez); acessos recentes vêm
// do localStorage (gravados no afterEach do router) — custo zero de backend.
export const RECENT_ROUTES_KEY = "xpost-recent-routes";

export default {
  name: "HomeShortcuts",
  props: {
    // lista plana de itens do menu do usuário ({ name, path, father, favorite })
    menuItems: { type: Array, default: () => [] },
  },
  computed: {
    favorites() {
      return this.menuItems.filter((item) => item.favorite && item.path).slice(0, 6);
    },
    recents() {
      let paths = [];
      try {
        paths = JSON.parse(localStorage.getItem(RECENT_ROUTES_KEY) || "[]");
      } catch (error) {
        return [];
      }
      const favoritePaths = this.favorites.map((item) => item.path);
      return paths
        .map((path) => this.menuItems.find((item) => item.path === path))
        .filter((item) => item && !favoritePaths.includes(item.path))
        .slice(0, 4);
    },
  },
};
</script>

<style>
.home-shortcuts__group-title {
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--me-text-secondary);
  margin: 10px 0 6px;
}

.home-shortcuts__group-title:first-child {
  margin-top: 0;
}

.home-shortcuts__links {
  display: flex;
  flex-wrap: wrap;
}

.home-shortcuts__link {
  display: inline-flex;
  align-items: center;
  padding: 4px 10px;
  margin: 0 6px 6px 0;
  border: 1px solid var(--me-border-light);
  border-radius: var(--me-radius-sm);
  font-size: 12px;
  color: var(--me-text-regular);
  cursor: pointer;
  transition: border-color 0.2s ease, color 0.2s ease, transform 0.15s ease;
}

.home-shortcuts__link:hover {
  border-color: var(--me-primary);
  color: var(--me-primary);
  transform: translateY(-1px);
}

.home-shortcuts__link i {
  margin-right: 5px;
  font-size: 13px;
  color: var(--me-text-secondary);
}

.home-shortcuts__link:hover i {
  color: var(--me-primary);
}
</style>
